// eslint-disable-next-line no-unused-vars
import React, {
    useEffect, useContext, useCallback
} from 'react';
import {
    renderContentFromMetadata,
    validateMetadata,
} from '@jutro/uiconfig';
import { TranslatorContext } from '@jutro/locale';
import Lottie from 'lottie-react';
import loaderAnimation from './loader_animation.json';
import styles from './loader.module.scss';
import uiMetadata from './loader.metadata.json5';
import message from './loader.messages';

function LoaderAnimation() {
    return (
        <Lottie
            animationData={loaderAnimation}
            loop
            autoplay
            className={styles.spinnerContainer}
        />
    );
}

function LoaderComponent({ showLoader }) {
    const translator = useContext(TranslatorContext);

    /**
     * @param {string} key
     * @returns content
     * get content on the basis of key
     */
    const fetchContent = useCallback(
        (key) => {
            return translator(message[key]);
        },
        [translator]
    );

    /* React useEffect hook */
    useEffect(() => {
        validateMetadata();
    });

    /* to override values at run time */
    const override = {
        loaderContent: {
            content: fetchContent('loadingContent'),
        },
        loaderMainContainer: {
            visible: showLoader
        }
    };

    /* to resolve custom styles and callback functions */
    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            LoaderAnimation
        },
        resolveCallbackMap: {
        }
    };

    /* to render the metadata */
    return renderContentFromMetadata(uiMetadata.loader, override, resolvers);
}

export default LoaderComponent;
